import React from 'react';

import { isMobile } from '../../helpers/utils';
import './style.css';

const MobileButton = () => (
    <div>
        <img
            alt="back to Notification center"
            className="iconImg" 
            src="/images/Back-Icon.png"            
        />
        <div className="icon-support-text mobile-font-family">Back</div>        
    </div>
);

const DesktopButton = ({text}) => (
    <div className="desktop-back-button">
        <img className="header" src="/images/ic-back.png" alt="back to Alerts"></img>
        <div>{ text }</div>        
    </div>
)

const BackButton = ({ href, text }) => (
    <div className="back-button">
        <a href={href} className="hreftextcolor"  tabIndex={0}>
            {
                isMobile() ? 
                    <MobileButton />:
                    <DesktopButton text={text} />
            }
        </a>
    </div>
);

export default BackButton;
